const defaults = {
  invalid: '#d9d9d9',
  white: '#ffffff',
  gray1: '#fefefe',
  gray2: '#f2f2f2',
  gray3: '#e6e6e6',
  gray4: '#d9d9d9',
  gray5: '#bfbfbf',
  gray6: '#a6a6a6',
  gray7: '#8c8c8c',
  gray8: '#737373',
  gray9: '#595959',
  gray10: '#404040',
  gray11: '#262626',
  gray12: '#1a1a1a',
  gray13: '#0c0c0c',
  near_black: '#0c0c0c',
};

const cnn_red = [
  ['#cc0000'],
  ['#ff7f5c', '#660000'],
  ['#ff7f5c', '#e01c0e', '#660000'],
  ['#ff7f5c', '#ff3f27', '#b90000', '#660000'],
  ['#ff7f5c', '#ff4f34', '#e01c0e', '#a50000', '#660000'],
  ['#ff7f5c', '#ff583b', '#f9321d', '#c80000', '#980000', '#660000'],
  ['#ff7f5c', '#ff5f41', '#ff3f27', '#e01c0e', '#b90000', '#900000'],
  ['#ff7f5c', '#ff6344', '#ff482e', '#f22c19', '#cf0502', '#ad0000', '#8a0000', '#660000'],
];

const red = [
  ['#ff3f3f'],
  ['#ff7a70', '#7d0000'],
  ['#ff7a70', '#e2282e', '#7d0000'],
  ['#ff7a70', '#ff4343', '#c1001b', '#7d0000'],
  ['#ff7a70', '#ff514d', '#e2282e', '#b00012', '#7d0000'],
  ['#ff7a70', '#ff5954', '#f7393a', '#ce1323', '#a6000c', '#7d0000'],
  ['#ff7a70', '#ff5e58', '#ff4343', '#e2282e', '#c1001b', '#9f0008', '#7d0000'],
  ['#ff7a70', '#ff625c', '#ff4b49', '#f13437', '#d41a26', '#b70016', '#9a0006', '#7d0000'],
];

const orange = [
  ['#ff7c00'],
  ['#ffa131', '#862400'],
  ['#ffa131', '#d75e00', '#862400'],
  ['#ffa131', '#f37300', '#bc4a00', '#862400'],
  ['#ffa131', '#ff7e03', '#d75e00', '#ae4100', '#862400'],
  ['#ffa131', '#ff8510', '#e86b00', '#c65200', '#a63b00', '#862400'],
  ['#ffa131', '#ff8916', '#f37300', '#d75e00', '#bc4a00', '#a13700', '#862400'],
  ['#ffa131', '#ff8c1b', '#fb7900', '#e36700', '#cb5600', '#b44500', '#9d3400', '#862400'],
];

const yellow = [
  ['#f0b100'],
  ['#ffc11e', '#835200'],
  ['#ffc11e', '#bf8600', '#835200'],
  ['#ffc11e', '#d49800', '#aa7400', '#835200'],
  ['#ffc11e', '#dfa200', '#bf8600', '#a06b00', '#835200'],
  ['#ffc11e', '#e6a800', '#cc9100', '#b37b00', '#9a6600', '#835200'],
  ['#ffc11e', '#eaac00', '#d49800', '#bf8600', '#aa7400', '#966200', '#835200'],
  ['#ffc11e', '#eeaf00', '#da9e00', '#c88e00', '#b67e00', '#a56f00', '#946000', '#835200'],
];

const green = [
  ['#4bc88a'],
  ['#80fab8', '#006533'],
  ['#80fab8', '#23aa6f', '#006533'],
  ['#80fab8', '#46c386', '#00935a', '#006533'],
  ['#80fab8', '#54d092', '#23aa6f', '#008750', '#006533'],
  ['#80fab8', '#5dd899', '#39b97d', '#009c63', '#00804a', '#006533'],
  ['#80fab8', '#63de9e', '#46c386', '#23aa6f', '#00935a', '#007c46', '#006533'],
  ['#80fab8', '#67e2a1', '#4ecb8d', '#33b579', '#0ca066', '#008c54', '#007843', '#006533'],
];

const teal = [
  ['#60b9b1'],
  ['#99f1e9', '#005a54'],
  ['#99f1e9', '#45a098', '#005a54'],
  ['#99f1e9', '#60b9b1', '#268881', '#005a54'],
  ['#99f1e9', '#6ec6be', '#45a098', '#127c75', '#005a54'],
  ['#99f1e9', '#76cfc6', '#55afa7', '#33918a', '#00756e', '#005a54'],
  ['#99f1e9', '#7cd4cc', '#60b9b1', '#45a098', '#268881', '#00716a', '#005a54'],
  ['#99f1e9', '#80d8d0', '#68c1b9', '#51aaa3', '#38958e', '#1c817a', '#006d67', '#005a54'],
];

const blue = [
  ['#3061f2'],
  ['#9bd3ff', '#1800c4'],
  ['#9bd3ff', '#4073ff', '#1800c4'],
  ['#9bd3ff', '#5c91ff', '#2554e7', '#1800c4'],
  ['#9bd3ff', '#6ba1ff', '#4073ff', '#1843db', '#1800c4'],
  ['#9bd3ff', '#74abff', '#5185ff', '#2f60f1', '#1238d4', '#1800c4'],
  ['#9bd3ff', '#7ab1ff', '#5c91ff', '#4073ff', '#2554e7', '#0e30d0', '#1800c4'],
  ['#9bd3ff', '#7fb6ff', '#649aff', '#4c80ff', '#3466f6', '#1d4ae0', '#0c29cd', '#1800c4'],
];

const purple = [
  ['#9656d1'],
  ['#f0b0ff', '#40007a'],
  ['#f0b0ff', '#904fca', '#40007a'],
  ['#f0b0ff', '#ad6eea', '#742fad', '#40007a'],
  ['#f0b0ff', '#bd7efa', '#904fca', '#661b9f', '#40007a'],
  ['#f0b0ff', '#c787ff', '#a162dd', '#7f3cb9', '#5e0a97', '#40007a'],
  ['#f0b0ff', '#cd8eff', '#ad6eea', '#904fca', '#742fad', '#590091', '#40007a'],
  ['#f0b0ff', '#d293ff', '#b677f3', '#9c5cd8', '#8342be', '#6c24a5', '#55008e', '#40007a'],
];

const pink = [
  ['#fc2f59'],
  ['#ff7291', '#79000f'],
  ['#ff7291', '#e21349', '#79000f'],
  ['#ff7291', '#ff375f', '#c00034', '#79000f'],
  ['#ff7291', '#ff466b', '#e21349', '#af002a', '#79000f'],
  ['#ff7291', '#ff4f72', '#f72b56', '#ce003c', '#a40025', '#79000f'],
  ['#ff7291', '#ff5577', '#ff375f', '#e21349', '#c00034', '#9d0021', '#79000f'],
  ['#ff7291', '#ff597b', '#ff4066', '#f12552', '#d30040', '#b6002f', '#98001e', '#79000f'],
];


const gray = [
  ['#737373'],
  ['#dfdddd', '#1b1c1c'],
  ['#dfdddd', '#757575', '#1b1c1c'],
  ['#dfdddd', '#959595', '#565757', '#1b1c1c'],
  ['#dfdddd', '#a6a6a6', '#757575', '#484848', '#1b1c1c'],
  ['#dfdddd', '#b1b0b0', '#888888', '#626363', '#3f3f40', '#1b1c1c'],
  ['#dfdddd', '#b8b7b7', '#959595', '#757575', '#565757', '#393a3a', '#1b1c1c'],
  ['#dfdddd', '#bebdbc', '#9f9e9e', '#838282', '#686868', '#4e4e4f', '#353536', '#1b1c1c'],
];

const politics = {
  rep: [
    ['#ff3f3f'],
    ['#ff7a70', '#7d0000'],
    ['#ff7a70', '#e2282e', '#7d0000'],
    ['#ff7a70', '#ff4343', '#c1001b', '#7d0000'],
    ['#ff7a70', '#ff514d', '#e2282e', '#b00012', '#7d0000'],
    ['#ff7a70', '#ff5954', '#f7393a', '#ce1323', '#a6000c', '#7d0000'],
    ['#ff7a70', '#ff5e58', '#ff4343', '#e2282e', '#c1001b', '#9f0008', '#7d0000'],
    ['#ff7a70', '#ff625c', '#ff4b49', '#f13437', '#d41a26', '#b70016', '#9a0006', '#7d0000'],
  ],
  dem: [
    ['#3061f2'],
    ['#9bd3ff', '#1800c4'],
    ['#9bd3ff', '#4073ff', '#1800c4'],
    ['#9bd3ff', '#5c91ff', '#2554e7', '#1800c4'],
    ['#9bd3ff', '#6ba1ff', '#4073ff', '#1843db', '#1800c4'],
    ['#9bd3ff', '#74abff', '#5185ff', '#2f60f1', '#1238d4', '#1800c4'],
    ['#9bd3ff', '#7ab1ff', '#5c91ff', '#4073ff', '#2554e7', '#0e30d0', '#1800c4'],
    ['#9bd3ff', '#7fb6ff', '#649aff', '#4c80ff', '#3466f6', '#1d4ae0', '#0c29cd', '#1800c4'],
  ],
  lib: [
    ['#ffc61c'],
    ['#fec24b', '#906000'],
    ['#fec24b', '#c48e19', '#906000'],
    ['#fec24b', '#d69f2b', '#b27e02', '#906000'],
    ['#fec24b', '#e0a733', '#c48e19', '#a97700', '#906000'],
    ['#fec24b', '#e6ac38', '#cf9824', '#b9850c', '#a47200', '#906000'],
    ['#fec24b', '#eab03b', '#d69f2b', '#c48e19', '#b27e02', '#a16f00', '#906000'],
    ['#fec24b', '#ecb23d', '#dca32f', '#cc9521', '#bc8711', '#ad7a00', '#9e6d00', '#906000'],
  ],
  green: [
    ['#38ba79'],
    ['#7ffbb3', '#005924'],
    ['#7ffbb3', '#13a465', '#005924'],
    ['#7ffbb3', '#3ebf7d', '#008a4f', '#005924'],
    ['#7ffbb3', '#4fcd8a', '#13a465', '#007e44', '#005924'],
    ['#7ffbb3', '#59d692', '#30b474', '#009458', '#00763d', '#005924'],
    ['#7ffbb3', '#5fdc97', '#3ebf7d', '#13a465', '#008a4f', '#007139', '#005924'],
    ['#7ffbb3', '#64e09b', '#48c785', '#29af6f', '#00995c', '#008348', '#006e36', '#005924'],
  ],
  other: [
    ['#34d1c9'],
    ['#69f9f0', '#006e68'],
    ['#69f9f0', '#00aea7', '#006e68'],
    ['#69f9f0', '#1dc6be', '#009891', '#006e68'],
    ['#69f9f0', '#36d2ca', '#00aea7', '#008d87', '#006e68'],
    ['#69f9f0', '#41d9d1', '#00bcb5', '#00a19a', '#008781', '#006e68'],
    ['#69f9f0', '#48ded6', '#1dc6be', '#00aea7', '#009891', '#00837c', '#006e68'],
    ['#69f9f0', '#4de2da', '#2ccdc5', '#00b8b1', '#00a59e', '#00928b', '#00807a', '#006e68'],
  ],
  // sentiment
  pos: [
    ['#38ba79'],
    ['#7ffbb3', '#005924'],
    ['#7ffbb3', '#13a465', '#005924'],
    ['#7ffbb3', '#3ebf7d', '#008a4f', '#005924'],
    ['#7ffbb3', '#4fcd8a', '#13a465', '#007e44', '#005924'],
    ['#7ffbb3', '#59d692', '#30b474', '#009458', '#00763d', '#005924'],
    ['#7ffbb3', '#5fdc97', '#3ebf7d', '#13a465', '#008a4f', '#007139', '#005924'],
    ['#7ffbb3', '#64e09b', '#48c785', '#29af6f', '#00995c', '#008348', '#006e36', '#005924'],
  ],
  neg: [
    ['#ff7c05'],
    ['#ffa133', '#862400'],
    ['#ffa133', '#d75e00', '#862400'],
    ['#ffa133', '#f37300', '#bc4a00', '#862400'],
    ['#ffa133', '#ff7e08', '#d75e00', '#ae4100', '#862400'],
    ['#ffa133', '#ff8514', '#e86b00', '#c65200', '#a63b00', '#862400'],
    ['#ffa133', '#ff891a', '#f37300', '#d75e00', '#bc4a00', '#a13700', '#862400'],
    ['#ffa133', '#ff8c1e', '#fb7900', '#e36700', '#cb5600', '#b44500', '#9d3400', '#862400'],
  ],
};

const business = {
  green: [
    ['#00c59e'],
    ['#65fcd2', '#006344'],
    ['#65fcd2', '#00aa85', '#006344'],
    ['#65fcd2', '#00c49d', '#00926e', '#006344'],
    ['#65fcd2', '#28d1a9', '#00aa85', '#008663', '#006344'],
    ['#65fcd2', '#37d9b1', '#00b993', '#009b77', '#007f5d', '#006344'],
    ['#65fcd2', '#3fdfb6', '#00c49d', '#00aa85', '#00926e', '#007a59', '#006344'],
    ['#65fcd2', '#45e3ba', '#1acba4', '#00b58f', '#009f7b', '#008b68', '#007756', '#006344'],
  ],
  redorange: [
    ['#ff5037'],
    ['#ff8564', '#7f0000'],
    ['#ff8564', '#e03924', '#7f0000'],
    ['#ff8564', '#ff5138', '#c01f10', '#7f0000'],
    ['#ff8564', '#ff5e42', '#e03924', '#b01006', '#7f0000'],
    ['#ff8564', '#ff6549', '#f44830', '#cc2a18', '#a60301', '#7f0000'],
    ['#ff8564', '#ff6a4d', '#ff5138', '#e03924', '#c01f10', '#a00000', '#7f0000'],
    ['#ff8564', '#ff6e50', '#ff583e', '#ee432d', '#d22e1c', '#b6170a', '#9b0000', '#7f0000'],
  ],
  night: [
    ['#004969'],
    ['#76accf', '#003251'],
    ['#76accf', '#346d8e', '#003251'],
    ['#76accf', '#4a81a3', '#1d597a', '#003251'],
    ['#76accf', '#558bae', '#346d8e', '#0d4f70', '#003251'],
    ['#76accf', '#5b92b4', '#41799a', '#276182', '#014969', '#003251'],
    ['#76accf', '#6096b9', '#4a81a3', '#346d8e', '#1d597a', '#004665', '#003251'],
    ['#76accf', '#6399bc', '#5087a9', '#3e7597', '#2b6485', '#145374', '#004363', '#003251'],
  ],
  sky: [
    ['#00bcf0'],
    ['#55e3ff', '#005c8e'],
    ['#55e3ff', '#009bce', '#005c8e'],
    ['#55e3ff', '#00b2e5', '#0086b8', '#005c8e'],
    ['#55e3ff', '#09bdf2', '#009bce', '#007bad', '#005c8e'],
    ['#55e3ff', '#23c5f9', '#00a9dc', '#008ec1', '#0075a7', '#005c8e'],
    ['#55e3ff', '#2dcafe', '#00b2e5', '#009bce', '#0086b8', '#0071a2', '#005c8e'],
    ['#55e3ff', '#34cdff', '#00b8ec', '#00a5d8', '#0092c4', '#007fb2', '#006ea0', '#005c8e'],
  ],
  salmon: [
    ['#ff6674'],
    ['#ff919d', '#860023'],
    ['#ff919d', '#db4b5a', '#860023'],
    ['#ff919d', '#f8616f', '#be3547', '#860023'],
    ['#ff919d', '#ff6c7a', '#db4b5a', '#b02a3e', '#860023'],
    ['#ff919d', '#ff7381', '#ec5867', '#ca3e4f', '#a82338', '#860023'],
    ['#ff919d', '#ff7885', '#f8616f', '#db4b5a', '#be3547', '#a21e35', '#860023'],
    ['#ff919d', '#ff7b89', '#ff6775', '#e75463', '#cf4152', '#b62f42', '#9e1a32', '#860023'],
  ],
  gray: [
    ['#a3a3a3'],
    ['#dededd', '#474848'],
    ['#dededd', '#8c8c8d', '#474848'],
    ['#dededd', '#a6a6a6', '#747575', '#474848'],
    ['#dededd', '#b3b3b3', '#8c8c8d', '#686969', '#474848'],
    ['#dededd', '#bbbbbb', '#9b9b9b', '#7e7e7e', '#626263', '#474848'],
    ['#dededd', '#c1c1c0', '#a6a6a6', '#8c8c8d', '#747575', '#5d5e5e', '#474848'],
    ['#dededd', '#c5c5c4', '#adadad', '#979797', '#828282', '#6d6e6e', '#5a5b5b', '#474848'],
  ],
};

const authority = {
  ice: '#07473A',
  cbp: '#53A796',
};

const authorityLabel = {
  ice: '#07473A',
  cbp: '#53A796',
};

export {
  defaults,
  business,
  politics,
  cnn_red,
  red,
  orange,
  yellow,
  green,
  teal,
  blue,
  purple,
  pink,
  gray,
  authority,
  authorityLabel,
};
